import React from 'react';
import styled from 'styled-components';

import type { ActionSettingField } from 'model/actions';
import SettingFieldRenderer from './SettingFieldRenderer';

const StyledSection = styled.section`
  margin-bottom: 1.25rem;
`;

const StyledSectionLabel = styled.h4`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.colors.textMuted};
  margin: 0 0 0.625rem;
`;

const StyledMuted = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textMuted};
  font-weight: 300;
`;

interface OwnProps {
  settings: ActionSettingField[];
  values: Record<string, unknown>;
  onChange: (name: string, value: unknown) => void;
}

const SettingsSection = ({ settings, values, onChange }: OwnProps) => (
  <StyledSection>
    <StyledSectionLabel>Settings</StyledSectionLabel>
    {settings.length === 0 && <StyledMuted>No settings for this action.</StyledMuted>}
    {settings.map((field) => (
      <SettingFieldRenderer
        key={field.name}
        field={field}
        value={values[field.name]}
        onSettingChange={onChange}
      />
    ))}
  </StyledSection>
);

export default React.memo(SettingsSection);
